<template>
    <div class="feature-section pt-min-100 pb-70">
        <div class="container">
            <div class="section-title section-title-lg">
                <h2>{{ $t('home.featuresTitle') }}</h2>
            </div>
            <div class="container">
                <div class="row">
                    <div
                        class="col-md-6 col-lg-3 pb-30"
                        v-for="feature in featureItems"
                        :key="feature.route"
                    >
                        <div class="feature-card">
                            <div class="feature-card-header">
                                <div class="feature-card-thumb" :class="feature.thumbClass">
                                    <img v-lazy="featureImage(feature.image)" :alt="feature.alt || feature.title">
                                </div>
                                <span>{{ feature.title }}</span>
                            </div>
                            <div class="feature-card-body"> 
                                <p>{{ feature.description }}</p>
                                <router-link :to="feature.route" class="redirect-link">
                                    {{ $t('common.buttons.learnMore') }}
                                    <i class="icofont-rounded-right"></i>
                                </router-link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Feature',
    computed: {
        featureItems() {
            const features = this.$t('home.features')
            if (!Array.isArray(features)) {
                return []
            }
            const thumbClasses = ['feature-card-thumb-green', 'feature-card-thumb-blue', 'feature-card-thumb-violet', 'feature-card-thumb-violet']
            return features.map((feature, index) => ({
                ...feature,
                thumbClass: thumbClasses[index] || 'feature-card-thumb-green'
            }))
        }
    },
    methods: {
        featureImage(imageName) {
            if (!imageName) return ''
            return this.$ossImg(imageName)
        }
    }
}
</script>

<style scoped>
.feature-card-thumb img {
    width: 100%;
    height: 100%;
    object-fit: contain;
}

/* Keep all four cards at the same height */
.row {
    display: flex;
    flex-wrap: wrap;
}

.col-md-6.col-lg-3 {
    display: flex;
}

.feature-card {
    display: flex;
    flex-direction: column;
    height: 100%;
    width: 100%;
}

.feature-card-header {
    flex-shrink: 0;
}

.feature-card-body {
    display: flex;
    flex-direction: column;
    flex: 1;
}

.feature-card-body p {
    flex: 1;
    margin-bottom: 8px;
}

.feature-card-body .redirect-link {
    margin-top: auto;
}
</style>
